import React, { useState } from "react";
import { Group, TextInput, Popover, Text, UnstyledButton, Box, ActionIcon } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

export default function FilterSelectInput({
  value,
  options,
  isEditMode,
  selectedOptions,
  onChange,
  onClickRemove,
  TargetComponent
}) {
  const [opened, setOpened] = useState(false);
  const [search, setSearch] = useState("");

  const values = Array.isArray(options?.values) ? options.values : [];
  const selectedOption = values.find((item) => item.value === value);
  const filteredValues = values.filter((item) => item.name.toLowerCase().includes(search.toLowerCase()));

  const closePopover = () => {
    setSearch("");
    setOpened(false);
  };

  return (
    <Popover
      opened={isEditMode ? opened : false}
      onClose={isEditMode ? closePopover : undefined}
      position="bottom"
      placement="start"
      zIndex={99999}
      spacing={0}
      target={
        TargetComponent ? (
          <TargetComponent onClick={() => setOpened(!opened)} />
        ) : (
          <UnstyledButton
            py={2}
            px={5}
            sx={{
              borderRadius: 5,
              cursor: isEditMode ? "pointer" : "default",
              backgroundColor: selectedOption?.color || "#f3f3f3"
            }}
            onClick={() => setOpened(true)}
          >
            <Text size="sm" color="grey">{selectedOption?.name || "Empty"}</Text>
          </UnstyledButton>
        )
      }
    >
      <Group spacing={0} noWrap>
        <TextInput
          placeholder="Search option..."
          value={search}
          size="xs"
          onChange={(e) => setSearch(e.currentTarget.value)}
          sx={{ flex: 1 }}
          m={8}
          mr={typeof onClickRemove === "function" ? 2 : 8}
        />
        {typeof onClickRemove === "function" && (
          <ActionIcon mr={2} onClick={onClickRemove}>
            <FontAwesomeIcon icon={solid("xmark")} onClick={closePopover} />
          </ActionIcon>
        )}
      </Group>
      {filteredValues.map((option, option_key) => {
        const isSelected = Array.isArray(selectedOptions) && !!selectedOptions.find(value => value === option.value);
        return (
          <Group
            key={option_key}
            px={8}
            pb={8}
            sx={{ cursor: "pointer" }}
            onClick={() => {
              if (typeof onChange === "function") {
                onChange(option.value);
              }
              closePopover();
            }}
          >
            <Text
              size="xs"
              color="grey"
              p={5}
              style={{ backgroundColor: option.color || "#f3f3f3", borderRadius: 5 }}
            >
              {option.name}
            </Text>
            {isSelected && (
              <>
                <Box style={{ flex: 1 }} />
                <FontAwesomeIcon icon={solid("check")} />
              </>
            )}
          </Group>
        );
      })}
    </Popover>
  );
}